import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

/**
 * Converts a string into a URL-friendly slug.
 */
export const generateBaseSlug = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')       // Replace spaces with -
    .replace(/[^\w\-]+/g, '')   // Remove all non-word chars
    .replace(/\-\-+/g, '-');    // Replace multiple - with single -
};

/**
 * Generates a unique slug for a race event by checking the database for collisions.
 */
export const generateUniqueRaceSlug = async (name: string): Promise<string> => {
  const baseSlug = generateBaseSlug(name);
  let uniqueSlug = baseSlug;
  let counter = 1;
  let isUnique = false;

  const racesRef = collection(db, 'races');

  while (!isUnique) {
    const q = query(racesRef, where('slug', '==', uniqueSlug));
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      isUnique = true;
    } else {
      uniqueSlug = `${baseSlug}-${counter}`;
      counter++;
    }
  }

  return uniqueSlug;
};

/**
 * Generates a category slug. Categories are usually unique within a race, 
 * so we can just use the base slug without a global database check.
 */
export const generateCategorySlug = (name: string): string => {
  return generateBaseSlug(name);
};
